import { useLocation, Navigate } from "react-router-dom";
import { useMfaPolicy } from "@/hooks/useMfaPolicy";
import { isMfaExemptPath } from "@/lib/securityPolicy";

/**
 * Blocks privileged users from reaching protected application routes until
 * they have enrolled TOTP, per the organization MFA policy.
 * Enrollment state is resolved server-side, so bypassing the client route
 * still leaves the user without an MFA factor (and without step-up tokens).
 */
export function MfaGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { mustEnroll, isLoading } = useMfaPolicy();

  if (isLoading || isMfaExemptPath(location.pathname)) {
    return <>{children}</>;
  }

  if (mustEnroll) {
    return <Navigate to="/app/mfa-setup" state={{ enforced: true, from: location }} replace />;
  }

  return <>{children}</>;
}
